// extracted by mini-css-extract-plugin
export default {"arrow_btn__pc":"style_arrow_btn__pc__fyXvk","arrow_btn__mobile":"style_arrow_btn__mobile__3-CBV"};